<!--
 * @Author: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @Date: 2020-12-21 12:08:22
 * @LastEditors: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @LastEditTime: 2021-01-27 14:26:15
 * @Description: 
 * @FilePath: /hsylc2021/src/views/common/404.vue
-->
<template>
  <div class="page-404">
    <div class="sybold">未找到页面</div>
  </div>
</template>
<script>
export default {
  name: 'Page404',
  mounted: function() {
    this.$mountedRob();
  }
};
</script>
